import React, { useEffect, useState } from 'react'
import PartiTable from 'components/Shared/MuiTable/PartiTable'
import {
    getTaskPerformanceColumnsDef,
    getTaskPerformanceRowsDef,
    TaskPerformanceRowProps,
    TaskPerformanceGroupProps,
} from './TaskPerformanceTableDef'
import { TableViewType } from 'components/Shared/MuiTable'
import styled from 'styled-components'
import { CampaignState } from 'state/campaigns'
import { useNewTranslation } from 'hooks'
import { ReportSummaryContainer } from '../../utils'
import { getTaskPerformance, selectTaskPerformance } from 'state/campaignReport'
import { useDispatch, useSelector } from 'react-redux'
import { selectTasks } from 'state/tasks'
import { STATE_KEYS } from 'state/requests'
import { selectRequestsAreLoading } from 'state'
import Loading from 'components/Loading'
import { ReportContainer } from 'components/Submissions/Review/Report/styles'

interface TaskPerformanceProps {
    campaign: CampaignState
}

const TaskPerformance: React.FC<TaskPerformanceProps> = ({ campaign }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const taskPerformance = useSelector(selectTaskPerformance)
    const tasks = useSelector(selectTasks)
    const isLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.GetTaskPerformance]))

    const [expandRow, setExpandRow] = useState<boolean>(false)

    const onExpandClick = () => {
        setExpandRow(prev => !prev)
    }

    const taskPerformanceColumns = getTaskPerformanceColumnsDef(onExpandClick, expandRow)
    const taskPerformanceRows = getTaskPerformanceRowsDef(taskPerformance, campaign, tasks)

    useEffect(() => {
        dispatch(getTaskPerformance({ uuid: campaign.uuid }))
    }, [campaign.uuid])

    if (isLoading) return <Loading />

    return (
        <ReportContainer>
            {taskPerformanceRows.map((row: TaskPerformanceGroupProps, index: number) => {
                return (
                    <ReportSummaryContainer
                        key={index}
                        title={t('submission.campaignReport.campaignPerformance.TaskTitle', { taskName: row.title })}
                    >
                        <TableContainer expandRow={expandRow}>
                            <PartiTable
                                {...(row.steps.length > 0 && { tableHeight: 'auto' })}
                                viewType={TableViewType.TASK_PERFORMANCE}
                                headerHeight={36}
                                rowHeight={56}
                                getRowHeight={() => 'auto'}
                                columns={taskPerformanceColumns}
                                rows={(row.steps || []).filter(Boolean) as TaskPerformanceRowProps[]} // Filter out null/undefined values
                                isLoading={isLoading}
                                hideToolbar
                                disableColumnMenu
                                hideFooter
                                noPadding
                                hideTableBorder
                                isNewStyle
                            />
                        </TableContainer>
                    </ReportSummaryContainer>
                )
            })}
        </ReportContainer>
    )
}

export default TaskPerformance

const TableContainer = styled.div<{ expandRow: boolean }>`
    width: 100%;
    .MuiDataGrid-columnHeaders {
        color: ${({ theme }) => theme.colors.text.primary};
        background: ${({ theme }) => theme.colors.surface.infoPastel};
    }

    .align-left-header {
        .MuiDataGrid-columnHeaderTitleContainerContent {
            margin-left: 2px;
        }
    }

    [data-id='submetric'] {
        display: ${({ expandRow }) => (expandRow ? 'flex' : 'none')};
        transition: all 0.3s ease-in-out;
        background: ${({ theme }) => theme.colors.surface.tertiary};

        // hover effect
        &:hover {
            background: ${({ theme }) => theme.colors.surface.tertiary};
        }
    }

    .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox) .MuiDataGrid-columnHeaderTitleContainer {
        margin-right: 0;
    }

    .new-style-MUI .MuiDataGrid-columnHeaderTitle {
        color: ${({ theme }) => theme.colors.text.primary};
    }

    .MuiDataGrid-columnHeaderTitleContainerContent {
        margin: auto;
    }

    .title-cell {
        background: ${({ theme }) => theme.colors.surface.infoPastel};
    }

    .row-total {
        min-height: 36px;
        height: 36px;
        align-items: center;
        background: ${({ theme }) => theme.colors.surface.tertiary};

        .title-cell {
            min-height: 36px;
            height: 36px;
            background: ${({ theme }) => theme.colors.surface.tertiary};
        }
    }
`
